import { ArenaTournament, RegistrationStatus, TournamentStatus } from 'modules/arena/tournaments/types';

export const TOURNAMENT_STATUS_LABELS: Record<TournamentStatus, string> = {
  rascunho: 'Rascunho',
  publicado: 'Publicado',
  encerrado: 'Encerrado',
};

export const REGISTRATION_STATUS_LABELS: Record<RegistrationStatus, string> = {
  confirmada: 'Confirmada',
  aguardando_pagamento: 'Aguardando pagamento',
  cancelada: 'Cancelada',
};

// Open Praia Norte é o mesmo torneio que o jogador vê e se inscreve em
// pages/Tournaments — aqui é a visão de gestão da arena que o criou.
export const MOCK_ARENA_TOURNAMENTS: ArenaTournament[] = [
  {
    id: 'open-praia-norte',
    name: 'Open Praia Norte',
    sport: 'Beach Tennis',
    court: 'Areia 3',
    dateLabel: '28–29 set',
    registrationDeadlineLabel: '20 set',
    cancellationDeadlineLabel: '21 set',
    entryFeeLabel: 'R$ 180/dupla',
    prizeLabel: 'Troféu + vale-compras Decathlon',
    status: 'publicado',
    categories: [
      {
        id: 'mista-c',
        name: 'Mista C',
        capacity: 8,
        registrations: [
          { id: 'reg-1', participants: ['Rafael Nunes', 'Júlia M.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '2 set' },
          { id: 'reg-2', participants: ['Marina L.', 'Diego C.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '3 set' },
          { id: 'reg-3', participants: ['Ana P.', 'Léo S.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '4 set' },
          { id: 'reg-4', participants: ['Bia R.', 'Carla M.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '5 set' },
          { id: 'reg-5', participants: ['Bruno T.', 'Paula K.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '6 set' },
          { id: 'reg-6', participants: ['Igor F.', 'Renata V.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '8 set' },
          { id: 'reg-7', participants: ['Thiago B.', 'Fernanda O.'], mode: 'dupla', status: 'aguardando_pagamento', amountDue: 180, amountPaid: 90, registeredAtLabel: 'hoje' },
        ],
        waitlist: [
          { id: 'wait-1', participants: ['Caio R.', 'Sofia N.'], mode: 'dupla', waitingSinceLabel: 'ontem' },
        ],
      },
      {
        id: 'masculina-b',
        name: 'Masculina B',
        capacity: 8,
        registrations: [
          { id: 'reg-8', participants: ['Gabriel D.', 'Marcos P.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '1 set' },
          { id: 'reg-9', participants: ['Vitor H.', 'Pedro A.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '2 set' },
          { id: 'reg-10', participants: ['Rui Almeida', 'Yuri Santos'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '3 set' },
          { id: 'reg-11', participants: ['Diego C.', 'Léo S.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '4 set' },
          { id: 'reg-12', participants: ['Bruno T.', 'Thiago B.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '5 set' },
          { id: 'reg-13', participants: ['Marcos P.', 'Gabriel D.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '6 set' },
          { id: 'reg-14', participants: ['Caio R.', 'Igor F.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '7 set' },
          { id: 'reg-15', participants: ['Pedro A.', 'Vitor H.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '8 set' },
        ],
        waitlist: [
          { id: 'wait-2', participants: ['Renata V.', 'Fernanda O.'], mode: 'dupla', waitingSinceLabel: '9 set' },
          { id: 'wait-3', participants: ['Paula K.', 'Sofia N.'], mode: 'dupla', waitingSinceLabel: '10 set' },
          { id: 'wait-4', participants: ['Carla M.', 'Ana P.'], mode: 'dupla', waitingSinceLabel: 'hoje' },
        ],
      },
      {
        id: 'feminina-open',
        name: 'Feminina Open',
        capacity: 8,
        registrations: [
          { id: 'reg-16', participants: ['Sofia N.', 'Laura F.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '1 set' },
          { id: 'reg-17', participants: ['Camille S.', 'Fernanda O.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '3 set' },
          { id: 'reg-18', participants: ['Marina L.', 'Bia R.'], mode: 'dupla', status: 'confirmada', amountDue: 180, amountPaid: 180, registeredAtLabel: '5 set' },
          { id: 'reg-19', participants: ['Paula K.', 'Renata V.'], mode: 'dupla', status: 'aguardando_pagamento', amountDue: 180, amountPaid: 0, registeredAtLabel: 'hoje' },
        ],
        waitlist: [],
      },
    ],
  },
  {
    id: 'copa-aldeota-pickleball',
    name: 'Copa Aldeota de Pickleball',
    sport: 'Pickleball',
    court: 'Quadra 5',
    dateLabel: '18–19 out',
    registrationDeadlineLabel: '10 out',
    cancellationDeadlineLabel: '12 out',
    entryFeeLabel: 'R$ 120/dupla',
    prizeLabel: 'A definir',
    status: 'rascunho',
    categories: [
      {
        id: 'open',
        name: 'Open',
        capacity: 8,
        registrations: [],
        waitlist: [],
      },
    ],
  },
  {
    id: 'inverno-futevolei',
    name: 'Torneio de Inverno de Futevôlei',
    sport: 'Futevôlei',
    court: 'Areia 2',
    dateLabel: '15–16 ago',
    registrationDeadlineLabel: '8 ago',
    cancellationDeadlineLabel: '10 ago',
    entryFeeLabel: 'R$ 150/dupla',
    prizeLabel: 'Premiação em dinheiro (R$ 1.000 para o 1º lugar)',
    status: 'encerrado',
    categories: [
      {
        id: 'unica',
        name: 'Categoria Única',
        capacity: 8,
        registrations: [
          { id: 'reg-20', participants: ['Rui Almeida', 'Diego C.'], mode: 'dupla', status: 'confirmada', amountDue: 150, amountPaid: 150, registeredAtLabel: '20 jul' },
          { id: 'reg-21', participants: ['Marcos P.', 'Vitor H.'], mode: 'dupla', status: 'confirmada', amountDue: 150, amountPaid: 150, registeredAtLabel: '22 jul' },
        ],
        waitlist: [],
      },
    ],
  },
];
